import React from 'react';
import Loadable from 'react-loadable';
import RedirectOnce from 'app/ui/route/RedirectOnce';
import { SYSTEM_ERROR } from '../../../api/redux-route/routes';
import CenteredLoader from 'app/ui/core/common/CenteredLoader';
import { noticeError } from 'app/api/analytics/reporting';

function Loader(props) {
  function log(msg) {
    noticeError(msg);
  }

  if (props.isLoading) {
    if (props.timedOut) {
      log('Loader timed out');
      return <RedirectOnce to={SYSTEM_ERROR} />;
    } else if (props.pastDelay) {
      return <CenteredLoader fullScreen />;
    } else {
      return null;
    }
  } else if (props.error) {
    log('Loader error');
    return <RedirectOnce to={SYSTEM_ERROR} />;
  } else {
    return null;
  }
}

function loaderWithDelay(componentLoader) {
  return async function() {
    const result = await componentLoader();
    return new Promise(resolve => {
      setTimeout(() => {
        return resolve(result);
      }, 100);
    });
  };
}

export default function withLoading(componentLoader) {
  return Loadable({
    loading: Loader,
    loader: loaderWithDelay(componentLoader),
  });
}
